import { orpc } from '@/api/rpc/client';

export function invalidatePricelistCaseQueries(
  queryClient: {
    invalidateQueries: (options: { queryKey: readonly unknown[] }) => unknown;
  },
  extras?: { comments?: boolean; pricelists?: boolean },
): void {
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelistCases.get.key(),
  });
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelistCases.list.key(),
  });
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelistCases.timeline.key(),
  });
  if (extras?.comments === true) {
    void queryClient.invalidateQueries({
      queryKey: orpc.inventoryManagement.pricelistCases.listComments.key(),
    });
  }
  if (extras?.pricelists === true) {
    void queryClient.invalidateQueries({
      queryKey: orpc.inventoryManagement.pricelist.listAll.key(),
    });
  }
}
